export function $(id: string): HTMLElement | null {
    return document.getElementById(id);
}

export function $$(selector: string): NodeListOf<HTMLElement> {
    return document.querySelectorAll<HTMLElement>(selector);
}

export function show(el: HTMLElement | null): void {
    if (el) el.classList.remove("hidden");
}

export function hide(el: HTMLElement | null): void {
    if (el) el.classList.add("hidden");
}

export function highlightWinLine(pi: number, line: [number, number][]): void {
    line.forEach(([r, c]) => {
        const el = $(`cell-${pi}-${r}-${c}`);
        if (el) el.classList.add("win-glow");
    });
}

/** Short combining vowels: dash + single mark (sara i through sara uu). */
const SHORT_COMBINING_RE = /^-[\u0E34-\u0E39]$/;

/**
 * Render a Thai character into an element. For the 13 vowels where `-`
 * is followed by a Thai combining mark or sara am, replaces the dash
 * with a thin space (U+2009) so the mark renders without a visible dash.
 * Short combining vowels (-ิ -ี -ึ -ื -ุ -ู) get a `small-vowel` class
 * so CSS can scale them up for visibility.
 */
export function renderCharContent(el: HTMLElement, char: string): void {
    el.textContent = char.replace(/-(?=[\u0E31\u0E33\u0E34-\u0E3A\u0E47-\u0E4E])/g, "\u2009");
    el.classList.toggle("small-vowel", SHORT_COMBINING_RE.test(char));
}
